<template>
  <div>
    <div class="detail">
      <div class="container">
        <div class="right" style="overflow: scroll">
          <div v-for="(item, index) in imageList" :key="index">
            <el-image
              style="width: 100%"
              :src="item.imageUrl"
              :preview-src-list="[item.imageUrlList]"
            >
            </el-image>
          </div>
        </div>
        <div class="left">
          <div style="width: 62%; margin: 0 auto">
            <InfoDetail ref='InfoDetail' :info="currentItems" style="width: 100%"></InfoDetail>
            <div>
              <div>
                <div class="section4">
                  <span>商品价格表</span>
                </div>
                <div class="billList" style="padding: 20px">
                  <div class="item" style="width: 100%; margin-bottom: 25px">
                    <div class="content" style="width: 100%; font-size: 20px">
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            起订量
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 810px;
                              text-align: center;
                              padding: 15px 0;
                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            pcs/rmb
                          </div>
                        </div>
                      </div>
                      <div
                        class="items"
                        style="width: 100%; display: flex"
                        v-for="(item, index) in currentItems.commodityPriceList"
                        :key="index"
                      >
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;
                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            {{ item.startNum }}
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;
                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ item.priceAfter }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="section4">
                  <span>商品规格</span>
                </div>
                <div class="billList" style="padding: 20px">
                  <div class="item" style="width: 100%; margin-bottom: 25px">
                    <div class="content" style="width: 100%; font-size: 20px">
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            产品名称
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 810px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{
                              currentItems.brandName +
                              "-" +
                              currentItems.cidefine8 +
                              currentItems.cinvCName
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            产品货号
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.cinvCode }}
                          </div>
                        </div>
                      </div>

                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            产品材质
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.material }}
                          </div>
                        </div>
                      </div>
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            测量尺寸
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.invstd }}
                          </div>
                        </div>
                      </div>
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            产品重量
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.invweight }}
                          </div>
                        </div>
                      </div>

                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            装箱规格(个)
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.packingQuantity }}
                          </div>
                        </div>
                      </div>
                      <div class="items" style="width: 100%; display: flex">
                        <div class="cell" style="width: 100%; display: flex">
                          <div
                            class="title"
                            style="
                              width: 400px;
                              padding: 15px 0;
                              text-align: center;

                              border-bottom: 1px solid #8b8b8b;
                              font-weight: bold;
                            "
                          >
                            库存
                          </div>
                          <div
                            class="msg"
                            style="
                              width: 800px;
                              text-align: center;
                              padding: 15px 0;

                              border-bottom: 1px solid #8b8b8b;
                            "
                          >
                            {{ currentItems.totalQuantity }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="new_goods_title_hot"
        style="display: flex; justify-content: center; width: 100%; margin-top: 100px"
      >
        <span>猜你喜欢</span>
      </div>
      <div
        class="recommend clearfix"
        style="display: flex; justify-content: center; width: 100%; flex-wrap: wrap"
      >
        <div class="item fl" v-for="item in hotgoodsList">
          <dl>
            <dt>
              <img :src="item.imageUrl | fullPath" alt="" />
            </dt>
            <div class="title">
              {{ item.brandName + "-" + item.cidefine8 + "-" + item.cinvCName }}
            </div>
            <div class="other clearfix" style="line-height: 36px; font-weight: 600">
              <span class="price fl">￥{{ parseFloat(item.price) }}/pcs</span>
            </div>
            <div style="display: flex">
              <div>
                <dd class="btn" style="margin-left: 15px">加入购物车</dd>
              </div>
              <div @click="buyGoods(item)" style="margin-left: 24px">
                <dd class="btn" style="margin-right: 15px">立即购买</dd>
              </div>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDcBasearchiveCommodity,
  getDcBasearchiveCommodityFile,
  hostGood,
} from "@/api/good/index.js";
import {
  getDcShoppingmallShoppingcart,
  deleteDcShoppingmallShoppingcart,
  editDcShoppingmallShoppingcart,
} from "@/api/cart/index.js";
import shopOrder from "./shopOrder/index.vue";
import Zoom from "./Detail/Zoom.vue";
import ImgList from "./Detail/ImgList.vue";
import InfoDetail from "./Detail/InfoDetailCart.vue";
import InfoDetailOther from "./Detail/infoDetailOther.vue";
import { mapState } from "vuex";
export default {
  name: "DetailPrds",
  data() {
    return {
      isHome: false,
      skuId: undefined,
      dialogTableVisible: false,
      skuNum: 1,
      dialogImageUrl: "",
      currentItems: {},
      imageList: [],
      currentItem: {},
      hotgoodsList: [],
    };
  },
  // computed: {
  //     ...mapState(['currentItem'])
  // },
  mounted() {
    // document.title = this.currentItem.content;
    // // 当前商品为空，跳装到首页
    // if (Object.keys(this.currentItem).length === 0) {
    //   this.$router.push({ name: "home" });
    // }
    console.log(this.$route.query.cinvCode);

    window.scrollTo(0, 0);
  },
  created() {
    getDcBasearchiveCommodity({
      cInvCode: this.$route.query.cinvCode,
      pageNum: 1,
      pageSize: 10,
    }).then((res) => {
      if (res.code == 200) {
        this.currentItems = res.data.list[0];
        // if(!this.currentItems.)
        getDcBasearchiveCommodityFile({
          cInvCode: this.$route.query.cinvCode,
          pageNum: 1,
          pageSize: 10,
          fileType: 3,
        }).then((resp) => {
          if (resp.code == 200) {
            this.imageList = resp.data;
            this.imageList.forEach((item) => {
              item.imageUrl = this.$locationUrl + "file/" + item.fileurl;
              item.imageUrlList = [item.imageUrl];
              console.log(item.imageUrl);
            });
            getDcShoppingmallShoppingcart({
              shoppingCartId: this.$route.query.shoppingCartId,
              pageNum: 1,
              pageSize: 10,
            }).then(resj=>{
                console.log(resj.data[0].quantity)
                this.$refs.InfoDetail.buyCount=resj.data[0].quantity
            })
          }
        });
      }
    });
    hostGood({ pageSize: 4, pageNum: 1,brandName:this.brandName,organizationId:this.organizationNames == "迪拜" ? 2 : 1 }).then((res) => {
      this.hotgoodsList = res.data.list;
      this.hotgoodsList.forEach((item) => {
        item.imageUrl = this.$locationUrl + "file/" + item.imageUrl;
        console.log(item.imageUrl);
      });
      console.log(this.hotgoodsList);
    });
  },
  components: {
    Zoom,
    ImgList,
    InfoDetail,
    InfoDetailOther,
    shopOrder,
  },
  methods: {
    buyGoods(item) {
     this.$myGlobalMethod(
        this.$locationViewUrl + "#/goods/Detail?cinvCode=" + item.cinvCode+"&brandName="+this.brandName,
        "_blank"
      );
    },
    dialogVisibleClick(item) {
      this.dialogVisible = true;
      this.dialogImageUrl = item;
    },
    changeImage(v) {
      console.log(v);
      let that = this;
      this.$nextTick(() => {
        that.$set(that.currentItem, "img", v);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new_goods_title_hot {
  height: 40px;

  margin-top: 140px;
  margin-bottom: 140px;

  span {
    font-size: 40px;
    line-height: 28px;

    padding-left: 15px;
    font-weight: bold;
    font-size: 40px;
  }
}
.recommend {
  margin-top: 20px;

  .item {
    // height: 510px;
    margin-left: 20px;
    margin-bottom: 12px;
    width: 21%;

    .recommend_left {
      height: 280px;
      width: 360px;

      img {
        width: 400px;
        height: 320px;
      }

      &:hover {
        cursor: pointer;
      }
    }

    &:nth-child(1),
    &:nth-child(4n + 1) {
      margin-left: 0;
    }

    dl {
      width: 100%;
      // border: 1px solid #eee;

      &:hover {
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
        width: 100%;
      }

      img {
        width: 100%;
        // height: 400px;
        // &:hover {
        //   width: 440px;
        //   width: 440px;
        // }
      }

      dd {
        padding: 0 5px;
      }

      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        font-weight: 700;
        color: black;
        line-height: 28px;
      }

      .other {
        .price {
          font-size: 17px;
          color: black;
          font-weight: 600;
        }

        .wei {
          font-size: 14px;
          color: #666;
        }
      }

      .btn {
        line-height: 28px;
        text-align: center;
        color: black;
        border: 1px solid black;
        box-sizing: border-box;
        border-radius: 30px;
        margin: 6px auto 10px auto;
        display: block;
        line-height: 20px;
        font-size: 14px;
        font-weight: 700;
        &:hover {
          color: #fff;
          background: black;
        }
      }
    }
  }

  .null {
    width: 188px;
    border: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.container {
  display: flex;
}
.left {
  position: sticky;
  top: 150px;
  height: 100vh; /* 设置左侧模块高度为视口高度 */
  width: 50%; /* 设置左侧模块宽度 */
  display: flex;
  justify-content: center;
  overflow: scroll;
}
.right {
  flex: 1;
  overflow: scroll;
  height: 100vh; /* 设置右侧模块高度，使其能够滚动 */
  // background: lightgreen;
}
.left::-webkit-scrollbar {
  display: none;
}

/* 隐藏 IE 和 Edge 浏览器滚动条 */
.left {
  -ms-overflow-style: none;
}
.right::-webkit-scrollbar {
  display: none;
}

/* 隐藏 IE 和 Edge 浏览器滚动条 */
.right {
  -ms-overflow-style: none;
}
.tb-item-info {
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #e8e8e8;
  justify-content: space-between;
}

.mask {
  z-index: 10;
  top: -8px;
  right: 15px;
  width: 30px;
  height: 21px;
  text-align: center;
  background-color: #fff;
}

.section4 {
  position: relative;
  text-align: center;
  margin-bottom: 25px;
  background: #fff;

  & > span {
    position: relative;
    display: inline-block;
    margin: 25px auto;
    font-weight: 700;
    font-size: 22px;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      display: inline-block;
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(rgba(255, 166, 0, 0.929412)),
        to(#ff6a00)
      );
      background: linear-gradient(90deg, rgba(255, 166, 0, 0.929412), #ff6a00);
      width: 40%;
      border-radius: 50px;
      height: 4px;
    }
  }

  .article_list {
    text-align: left;
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    flex-wrap: wrap;

    .article_item {
      border: 1px solid #eee;
      padding: 10px 30px;
      margin: 10px 0;
      width: 44%;
      cursor: pointer;

      &:hover {
        box-shadow: 0 0 5px 1px #dcdfe6;

        .title a {
          color: #ff6a00;
        }
      }

      .title {
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .summary {
        color: #767676;
        font-size: 14px;
      }

      .title a {
        font-size: 18px;
        color: #333;
      }

      .title {
        p {
          color: #999;
        }
      }
    }
  }
}

.table-header {
  width: 92%;
  margin-left: 6%;
  margin-right: 2%;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Medium;
  color: #092553;
  font-weight: 900;
  font-size: 19px;
}

.table-header-title {
  border-radius: 2.5px;
  width: 5px;
  height: 16px;
  margin-right: 15px;
  background-color: #28bd9c;
}

.billList {
  padding: 20px;

  .item {
    margin-bottom: 25px;

    .name {
      padding: 15px 0;
      font-weight: bold;
      text-align: center;
      border: 1px solid #e8e8e8;
      font-size: 30px;
    }

    .content {
      font-size: 26px;

      .items {
        display: flex;
        // border-left: 1px solid #e8e8e8;

        .cell {
          width: 355px;
          display: flex;

          .title {
            width: 150px;
            padding: 15px 0;
            text-align: center;
            // border-right: 1px solid #e8e8e8;
            // border-bottom: 1px solid #e8e8e8;
            font-weight: bold;
          }

          .msg {
            width: 205px;
            text-align: center;
            padding: 15px 0;
            // border-right: 1px solid #e8e8e8;
            border-bottom: 1px solid #8b8b8b;
          }
        }
      }
    }
  }
}
</style>
